<template>
  <div>
    <v-avatar
      :size="size"
      v-if="noImage"
      :class="textSize"
      class="white--text"
      :color="'primary'"
      id="profile-image"
    >
      {{ letters }}
    </v-avatar>
    <v-avatar
      :size="size"
      v-if="!noImage"
      :class="textSize"
      class="white--text"
      :color="'primary'"
      id="profile-image"
    >
      <v-img :src="imagePath"></v-img>
    </v-avatar>
    <v-icon v-if="upload" id="profile-camera" :color="position" @click="openModal"
      >$veutify.icons.camera</v-icon
    >
    <!--Upload Image Modal-->
    <v-dialog v-model="uploadImageModal" max-width="600" persistent>
      <v-card class="pa-5 pt-0 rounded-xl" id="change-image-card">
        <v-card-title class="pb-6 pl-0 pr-0">
          <v-row>
            <v-col sm="12" class="justify-left d-flex text-bold">
              {{ $t('change-image') }}
            </v-col>
          </v-row>
          <v-btn icon @click="uploadImageModal = false" left>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text justify="center" class="upload-image">
          <v-row v-if="image.name">
            <v-col cols="12" md="12" class="center pt-11">
              {{ image.name }}
              <v-icon id="clear-image" @click="image = {}">mdi-close</v-icon>
            </v-col>
          </v-row>
          <v-row
            class="pt-5"
            align="center"
            v-if="!image.name"
            @drop.prevent="onDrop($event)"
            @dragover.prevent="dragover = true"
            @dragenter.prevent="dragover = true"
            @dragleave.prevent="dragover = false"
            id="file-upload"
          >
            <input
              id="dropzone-file"
              type="file"
              class="hidden"
              accept="image/*"
              @change="selectImage($event)"
            />
            <v-col cols="12" md="12" class="text-center pt-11">
              <img
                class="upload-image-svg"
                :src="require('@/assets/svg/upload.svg')"
                alt="upload svg"
              />
            </v-col>
            <v-col cols="12" md="12" class="text-center">
              <p>{{ $t('drag-and-drop') }}</p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col cols="6" class="d-flex justify-end">
              <v-btn
                depressed
                rounded
                x-large
                class="neutral800--text font-weight-bold"
                color="neutral"
                outlined
                @click="uploadImageModal = false"
                >{{ $t('cancel') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                depressed
                rounded
                x-large
                class="white--text font-weight-bold"
                color="neutral"
                :disabled="image.length == 0"
                @click="uploadImage()"
                >{{ $t('upload') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import profile from '@/services/profile-service';
import util from '@/mixins/util';
import EventBus from '@/helpers/event-bus';
import Store from '@/store/store';

export default {
  name: 'ProfileImage',
  mixins: [profile, util],
  props: {
    size: {
      type: String,
      default: '50px',
    },
    textSize: {
      type: String,
      default: 'text-sm-body-1',
    },
    upload: {
      type: Boolean,
      default: false,
    },
    position: String,
  },
  data() {
    return {
      noImage: true,
      letters: '',
      imagePath: '',
      uploadImageModal: false,
      image: {},
      dragover: false,
    };
  },
  mounted() {
    const name = this.$store.getters.fullName ? this.$store.getters.fullName.split(' ') : [];
    if (name.length >= 2) {
      this.letters = name[0][0] + name[1][0];
    } else if (name.length === 1) {
      this.letters = name[0][0];
    } else {
      this.letters = '';
    }
    this.addImage();
    this.$store.subscribe((mutation, state) => {
      if (state.imageChanged) {
        this.refresh();
      }
    });
  },
  methods: {
    addImage() {
      if (this.$store.getters.imagePath && this.$store.getters.imagePath !== 'null') {
        this.noImage = false;
        this.imagePath = this.$store.getters.imagePath;
      } else {
        this.refresh();
      }
    },
    refresh() {
      this.getImage()
        .then(res => {
          if (res.data && res.data.size) {
            this.createImage(res.data)
              .then(img => {
                localStorage.imagePath = img;
                this.imagePath = localStorage.imagePath;
                this.noImage = false;
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            this.noImage = true;
            localStorage.imagePath = null;
          }
          Store.commit('setImagePath', localStorage.imagePath);
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.$store.commit('setImageChanged', false);
        });
    },
    selectImage(e) {
      this.image = e.target.files[0];
      console.log(this.image.name);
    },
    onDrop(e) {
      this.dragover = false;
      this.image = e.dataTransfer.files[0];
    },
    uploadImage() {
      this.putImage(this.image)
        .then(response => {
          if (response.status === 200) {
            EventBus.$emit('snackbar', {
              text: this.$i18n.t('file-uploaded'),
            });
            this.uploadImageModal = false;
            this.$store.commit('setImageChanged', true);
            this.refresh();
          } else {
            console.log(response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          // this.message = prevMessage + 'Could not upload the file:' + file.name;
        });
    },
    openModal() {
      if (this.upload) {
        this.uploadImageModal = true;
      }
    },
  },
};
</script>
